/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NFLRedzoneAdvantagePagePassingQueryVariables = {|
  teamIds?: ?$ReadOnlyArray<?string>,
  minAtt?: ?number,
  seasonID?: ?string,
|};
export type NFLRedzoneAdvantagePagePassingQueryResponse = {|
  +nflRedzonePassingStats: ?$ReadOnlyArray<?{|
    +player: {|
      +firstName: string,
      +lastName: string,
      +position: {|
        +name: ?string
      |},
      +team: ?{|
        +logoSrc: ?string
      |},
    |},
    +attempts: number,
    +interceptions: number,
    +completions: number,
    +touchdowns: number,
  |}>
|};
export type NFLRedzoneAdvantagePagePassingQuery = {|
  variables: NFLRedzoneAdvantagePagePassingQueryVariables,
  response: NFLRedzoneAdvantagePagePassingQueryResponse,
|};
*/


/*
query NFLRedzoneAdvantagePagePassingQuery(
  $teamIds: [ID]
  $minAtt: Int
  $seasonID: ID
) {
  nflRedzonePassingStats(teamIds: $teamIds, minAtt: $minAtt, seasonId: $seasonID) {
    player {
      firstName
      lastName
      position {
        name
        id
      }
      team {
        logoSrc
        id
      }
      id
    }
    attempts
    interceptions
    completions
    touchdowns
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minAtt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seasonID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v3 = [
  {
    "kind": "Variable",
    "name": "minAtt",
    "variableName": "minAtt"
  },
  {
    "kind": "Variable",
    "name": "seasonId",
    "variableName": "seasonID"
  },
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoSrc",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attempts",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interceptions",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completions",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "touchdowns",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NFLRedzoneAdvantagePagePassingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NFLRedzonePassingStatsType",
        "kind": "LinkedField",
        "name": "nflRedzonePassingStats",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatPositionType",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatTeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "NFLRedzoneAdvantagePagePassingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NFLRedzonePassingStatsType",
        "kind": "LinkedField",
        "name": "nflRedzonePassingStats",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatPositionType",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatTeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "da31b9afc7d416762d14ff8ab6d2c10d",
    "id": null,
    "metadata": {},
    "name": "NFLRedzoneAdvantagePagePassingQuery",
    "operationKind": "query",
    "text": "query NFLRedzoneAdvantagePagePassingQuery(\n  $teamIds: [ID]\n  $minAtt: Int\n  $seasonID: ID\n) {\n  nflRedzonePassingStats(teamIds: $teamIds, minAtt: $minAtt, seasonId: $seasonID) {\n    player {\n      firstName\n      lastName\n      position {\n        name\n        id\n      }\n      team {\n        logoSrc\n        id\n      }\n      id\n    }\n    attempts\n    interceptions\n    completions\n    touchdowns\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a07297d2618e38805e16e3b9cc6197b2';

module.exports = node;
